var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhLogocda7F338(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4172 32.0125V56.1312H20.1767C18.3623 56.1312 16.8906 54.6314 16.8906 52.7818V35.3619C16.8906 33.5123 18.36 32.0125 20.1767 32.0125H21.4172Z",
    fill: "url(#paint0_linear_788_4084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4329 53.2723C25.3766 52.4109 25.0586 51.5377 25.0586 50.4099C25.0586 49.2821 25.4881 48.3502 26.5479 47.49L34.4298 41.0692C35.3852 41.7229 34.0496 47.213 34.0496 47.213L26.4329 53.2723Z",
    fill: "url(#paint1_linear_788_4084)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4172 59.0007V62.9182H20.1767C18.3623 62.9182 16.8906 61.4113 16.8906 59.5535V55.6371C16.8906 57.4949 18.36 59.0007 20.1767 59.0007H21.4172Z",
    fill: "url(#paint2_linear_788_4084)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8084 42.6993C35.7334 44.5959 34.3884 46.902 34.3438 46.9736C34.3697 46.9149 34.9588 45.5195 35.9998 42.6312C36.5772 41.0293 36.204 40.6361 35.1665 39.8533C34.9893 39.7195 29.0744 35.1061 24.7461 31.7308V29.6347C29.3396 33.3304 35.744 38.4943 35.974 38.6738C37.4375 39.7782 38.1205 40.3826 36.8084 42.6993Z",
    fill: "url(#paint3_linear_788_4084)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6986 40.9964C38.4276 42.5632 34.5136 46.794 34.354 46.9677C34.3611 46.9513 36.896 43.3295 38.6412 40.9166C39.7068 39.4425 38.3231 38.6727 37.2857 37.8899C37.0721 37.7291 28.7747 31.3376 24.7539 28.2405V25.6844C29.2664 29.3061 38.728 36.9005 39.0015 37.1071C40.4591 38.2126 41.1433 39.2149 39.6986 40.9964Z",
    fill: "url(#paint4_linear_788_4084)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7524 41.0551L34.3587 46.9689C34.5664 46.7705 40.9685 40.9236 41.7794 39.5575C42.7066 37.9967 41.4719 37.7244 40.2009 36.5789C40.0167 36.4135 30.2429 28.4811 24.7539 24.0354V21.8173C30.9024 26.845 42.0435 35.9499 42.6714 36.4205C44.3332 37.6727 43.9705 39.2829 41.7524 41.0551Z",
    fill: "url(#paint5_linear_788_4084)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M42.1483 44.0287C42.4844 43.6211 38.2774 39.5968 32.7516 35.0401C27.2259 30.4834 22.4739 27.1198 22.1378 27.5274C21.8017 27.9349 26.0088 31.9593 31.5346 36.516C37.0603 41.0727 41.8123 44.4362 42.1483 44.0287Z",
    fill: "url(#paint6_radial_788_4084)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.51,
    d: "M60.2174 53.1724C65.2207 47.105 57.8245 32.7427 43.6976 21.0932C29.5707 9.44377 14.0626 4.91855 9.05927 10.9859C4.05597 17.0532 11.4521 31.4155 25.5791 43.065C39.706 54.7145 55.2141 59.2397 60.2174 53.1724Z",
    fill: "url(#paint7_radial_788_4084)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.51,
    d: "M14.0695 56.4517C19.8942 57.7478 26.8669 48.6832 29.6435 36.2054C32.4201 23.7275 29.9492 12.5615 24.1246 11.2654C18.2999 9.96928 11.3272 19.0339 8.55061 31.5117C5.77399 43.9895 8.2449 55.1556 14.0695 56.4517Z",
    fill: "url(#paint8_radial_788_4084)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M19.8038 46.125C27.7225 45.3443 33.5487 38.6958 32.8171 31.2751C32.0855 23.8544 25.073 18.4717 17.1544 19.2524C9.23574 20.0332 3.40951 26.6817 4.14114 34.1024C4.87277 41.523 11.8852 46.9058 19.8038 46.125Z",
    fill: "url(#paint9_radial_788_4084)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1073 38.8516C45.4367 38.4378 40.9976 34.3571 35.1923 29.7371C29.3871 25.1172 24.414 21.7075 24.0846 22.1213C23.7553 22.5352 28.1944 26.6159 33.9996 31.2358C39.8049 35.8558 44.7779 39.2655 45.1073 38.8516Z",
    fill: "url(#paint10_radial_788_4084)",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5496 39.7986C41.8275 39.4587 38.04 35.9026 33.0901 31.8558C28.1401 27.809 23.9021 24.8039 23.6243 25.1438C23.3464 25.4837 27.1338 29.0399 32.0838 33.0867C37.0337 37.1335 41.2717 40.1385 41.5496 39.7986Z",
    fill: "url(#paint11_radial_788_4084)",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1643 54.7383C17.6034 54.7371 17.9448 49.553 17.9269 43.1594C17.9091 36.7658 17.5387 31.5837 17.0996 31.585C16.6606 31.5862 16.3192 36.7702 16.337 43.1639C16.3549 49.5575 16.7253 54.7395 17.1643 54.7383Z",
    fill: "url(#paint12_radial_788_4084)",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1814 39.9662C37.3169 39.7945 34.8462 37.619 31.6629 35.1072C28.4795 32.5954 25.7891 30.6984 25.6536 30.8701C25.5181 31.0419 27.9888 33.2173 31.1721 35.7292C34.3554 38.241 37.0459 40.138 37.1814 39.9662Z",
    fill: "url(#paint13_radial_788_4084)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_788_4084",
    x1: 14.2007,
    y1: 54.7523,
    x2: 37.1835,
    y2: 11.0248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3D4AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5A47EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8A41F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC3AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_788_4084",
    x1: 23.5986,
    y1: 59.692,
    x2: 46.5814,
    y2: 15.9646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3D4AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5A47EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8A41F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC3AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_788_4084",
    x1: 19.9467,
    y1: 57.7719,
    x2: 42.9294,
    y2: 14.0445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3D4AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5A47EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8A41F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC3AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_788_4084",
    x1: 24.7625,
    y1: 55.6289,
    x2: 35.7944,
    y2: 25.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3D4AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5A47EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8A41F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC3AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_788_4084",
    x1: 19.5501,
    y1: 57.5642,
    x2: 42.5329,
    y2: 13.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3D4AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5A47EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8A41F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC3AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_788_4084",
    x1: 19.7978,
    y1: 57.6956,
    x2: 42.7817,
    y2: 13.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C52FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC02CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2785 35.4334) rotate(39.51) scale(11.3834 1.08413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F99EFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0319 31.6681) rotate(39.51) scale(29.2715 16.804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFF8FF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FCD0FF",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FAABFF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F88CFF",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F671FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F45CFF",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F34BFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F33FFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F238FF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.511 33.9808) rotate(102.545) scale(20.4351 12.7504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFF8FF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FCD0FF",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FAABFF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F88CFF",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F671FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F45CFF",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F34BFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F33FFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F238FF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2258 32.7377) rotate(84.3692) scale(11.9196 17.0886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFF8FF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FCD0FF",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FAABFF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F88CFF",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F671FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F45CFF",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F34BFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F33FFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F238FF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0346 29.8683) rotate(38.6776) scale(12.556 0.664971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#F99EFF",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6072 32.3262) rotate(39.5129) scale(10.1862 0.62233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F33AFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2569 43.0852) rotate(90.0852) scale(10.1862 0.62233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F33AFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_788_4084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4182 35.3394) rotate(38.4681) scale(6.46026 0.26838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#F99EFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F236FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhLogocda7F338);
export default __webpack_public_path__ + "static/media/ph_logo.cda7f338.e83f28b46bf4d0e28fc64e0d282c9526.svg";
export { ForwardRef as ReactComponent };